import React from "react";

import { noTransaction } from "../../assets/images";
import { useAdminUserRewardsQuery } from "../../lib/api/useUserActivityQueries";
import { UserActivityRewardsTable } from "./userActivityRewardsTable";

const Rewards = ({ customerId }: { customerId: string }) => {
  const { data: rewards = [], isPending } = useAdminUserRewardsQuery(customerId);

  return (
    <div className="w-full">
      <UserActivityRewardsTable
        rewards={rewards}
        isLoading={isPending}
        emptyImage={noTransaction}
      />
    </div>
  );
};

export default Rewards;
